import React from 'react';
import {
  StyledQuickFilterTab,
  StyledQuickFilterTabsContainer,
} from '../styles/QuickFilterTabs.styles';

const QuickFilterTabs = ({ tabs = [], selectedTab, handleTabSelection }) => {
  return (
    <StyledQuickFilterTabsContainer>
      {tabs?.map((tab) => (
        <StyledQuickFilterTab
          key={`quick-filter-tab-${tab.id}`}
          selected={selectedTab[0] === tab?.id}
          onClick={() => handleTabSelection(tab?.facetName, tab?.id)}
        >
          {tab?.displayName}
        </StyledQuickFilterTab>
      ))}
    </StyledQuickFilterTabsContainer>
  );
};

export default QuickFilterTabs;
